import { Tag } from "antd"

import type { AnswerReference } from "../../types/answerer"
import { getReferenceTagColorClass } from "./index"

const ReferenceBadge: React.FC<{
  reference: AnswerReference
  isVerbatimFromAnswerBank?: boolean
}> = ({ reference, isVerbatimFromAnswerBank }) => {
  let label: string
  if (isVerbatimFromAnswerBank) {
    label = "Answer straight from answer bank"
  } else if (reference.kind === "KNOWLEDGE_ITEM") {
    label = "Answer Bank"
  } else if (reference.kind === "WEB_SEARCH_RESULT") {
    label = "Website"
  } else if (reference.kind === "LINEAR_ISSUE") {
    label = "Linear Issue"
  } else {
    label = "Source Document"
  }
  return (
    <Tag
      className="text-xs font-semibold"
      rootClassName={getReferenceTagColorClass(reference)}
    >
      {label}
    </Tag>
  )
}

export default ReferenceBadge
